import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  Divider,
} from "@mui/material";
import { Work as WorkStatusIcon, Source as SourceIcon } from "@mui/icons-material";
import CustomSelect from "../FormFields/CustomSelect/CustomSelect";
import CardHeaderComponent from "./CardHeaderComponent";
import { iStatusOptions, jobRatingOptions, sourceOptions } from "./CandidateForm.Config";

const CandidateJobStatusSourceForm = ({ handleChange, formData }) => {
  const jobRatingOptionsFormatted = jobRatingOptions.map((item) => ({
    value: item.value,
    label: item.name || item.value,
  }));

  const iStatusOptionsFormatted = iStatusOptions.map((item) => ({
    value: item.value,
    label: item.name || item.value,
  }));

  const sourceOptionsFormatted = sourceOptions.map((item) => ({
    value: item.value,
    label: item.name || item.value,
  }));

  return (
    <Card
      variant="outlined"
      sx={{
        height: '100%',
        borderRadius: 2,
        borderColor: '#e2e8f0',
        boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
        overflow: 'hidden',
      }}
    >
      <CardHeaderComponent icon={WorkStatusIcon} title="Job Status & Source" />
      <CardContent sx={{ p: 2.5 }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12 }}>
            <CustomSelect
              options={jobRatingOptionsFormatted}
              label="Rating"
              name="rating"
              onChange={handleChange}
              value={formData?.rating || ""}
              placeholder="Select Rating"
              fullWidth
              size="small"
            />
          </Grid>
          
          <Grid size={{ xs: 12 }}>
            <CustomSelect
              options={iStatusOptionsFormatted}
              label="I-Status"
              name="interview_status"
              onChange={handleChange}
              value={formData?.interview_status || ""}
              placeholder="Select Interview Status"
              fullWidth
              size="small"
            />
          </Grid>

          <Grid size={{ xs: 12 }}>
            <Divider sx={{ my: 1 }} />
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
              <SourceIcon color="primary" sx={{ fontSize: 18 }} />
              <Typography variant="caption" fontWeight={600} color="text.secondary">
                SOURCE
              </Typography>
            </Box>
          </Grid>

          <Grid size={{ xs: 12 }}>
            <CustomSelect
              options={sourceOptionsFormatted}
              label="Source"
              name="source"
              onChange={handleChange}
              value={formData?.source || ""}
              placeholder="Select Source"
              fullWidth
              size="small"
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CandidateJobStatusSourceForm;